import { Store } from '../../core/createStore';
import OrderRepository from '../../service/orderRepository';
import ProductRepository from '../../service/productRepository';
import {
  dispose,
  startFetch,
  finishFetch,
} from "../../state/confirm";
import OrderProduct from "../../entity/orderProduct";

class Confirm {
  private orderRepository: OrderRepository;
  private productRepository: ProductRepository;
  private store: Store;

  constructor({
    orderRepository,
    productRepository,
    store,
  }: {
    orderRepository: OrderRepository;
    productRepository: ProductRepository;
    store: Store;
  }) {
    this.orderRepository = orderRepository;
    this.productRepository = productRepository;
    this.store = store;
  }

  public async initialize(): Promise<void> {
    const session = this.store.getState().currentSession;
    const currentStore = this.store.getState().currentStore;

    try {
      if (!session || !currentStore) {
        throw new Error('It is cannot have reach here.');
      }

      this.store.dispatch(startFetch());

      const res = await this.orderRepository.getOrderWithProducts(session);
      const orderProducts = await new Map(
        await Promise.all(
          await res.orderProducts.map(async orderProduct => {
            return [orderProduct.productId as string, orderProduct] as [string, OrderProduct];
          }),
        ),
      );
      const products = await this.searchProducts(Array.from(orderProducts.values()));

      this.store.dispatch(finishFetch({
        order: res.order,
        products,
        orderProducts,
      }));
    } catch (e) {
      this.store.dispatch(finishFetch(null));
      throw e;
    }
  }

  public async searchProducts(
    orderProducts: OrderProduct[],
  ) {
    const session = this.store.getState().currentSession;

    if (!session) {
      throw new Error('It is cannot have reach here.');
    }

    return await Promise.all(
      await orderProducts.map(async (orderProduct) => {
        return await this.productRepository.getProduct(session, { id: orderProduct.productId });
      }
    ));
  }

  public async buy() {
    const session = this.store.getState().currentSession;

    if (!session) {
      throw new Error('It is cannot have reach here.');
    }

    try {
      await this.orderRepository.buyOrder(session);
    } catch (err) {
      throw err;
    }
  }

  public dispose(): void {
    this.store.dispatch(dispose());
  }
}

export default Confirm;
